import type { Offer, OfferListItem, OfferAnalytics, DailyDownload } from '../types/data';
import type {
  OfferApiResponse,
  OfferListItemApiResponse,
  OfferAnalyticsApiResponse,
  DailyDownloadApiResponse,
} from '../types/responses';

export function offerMapper(offer: OfferApiResponse): Offer {
  return {
    id: offer.id,
    title: offer.title,
    description: offer.description,
    pdfUrl: offer.pdf_url,
    coverImageUrl: offer.cover_image_url,
    thumbnailUrl: offer.thumbnail_url,
    fileSize: offer.file_size,
    status: offer.status,
    createdAt: offer.created_at,
    updatedAt: offer.updated_at,
  };
}

export function offerListItemMapper(offer: OfferListItemApiResponse): OfferListItem {
  return {
    id: offer.id,
    title: offer.title,
    description: offer.description,
    coverImageUrl: offer.cover_image_url,
    thumbnailUrl: offer.thumbnail_url,
    fileSize: offer.file_size,
    status: offer.status,
    createdAt: offer.created_at,
  };
}

export function dailyDownloadMapper(daily: DailyDownloadApiResponse): DailyDownload {
  return {
    date: daily.date,
    ministryMatch: daily.ministry_match,
    email: daily.email,
    total: daily.total,
  };
}

export function offerAnalyticsMapper(analytics: OfferAnalyticsApiResponse): OfferAnalytics {
  return {
    offerId: analytics.offer_id,
    offerTitle: analytics.offer_title,
    dateRange: {
      startDate: analytics.date_range.start_date,
      endDate: analytics.date_range.end_date,
    },
    totalDownloads: analytics.total_downloads,
    ministryMatchDownloads: analytics.ministry_match_downloads,
    emailDownloads: analytics.email_downloads,
    dailyDownloads: analytics.daily_downloads.map(dailyDownloadMapper),
  };
}
